import { Controller } from "web-ui/controller"
import * as Log from "web-ui/log"

// Connects to data-controller="user-tools"
export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.debug("Connect")
  }

  disconnect() {
    this.debug("Disconnect")
  }

  isOpen() {
    return this.element.classList.contains("open")
  }

  closeMenu(event) {
    if (event && this.element.contains(event.target)) {
      return
    }

    this.element.classList.remove("open")
    this.buttonTarget.removeAttribute("aria-expanded")
  }

  openMenu() {
    this.element.classList.add("open")
    this.buttonTarget.setAttribute("aria-expanded", "true")
  }

  toggle() {
    if (this.isOpen()) {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }

  debug(message, data) {
    Log.debug("User Tools - " + message, data)
  }
}
